// Formatters and date helpers (pt-BR)

export const fmtBR = (d: string | Date | null | undefined): string => {
  // Vencimento/data ausente: mostrar travessão, nunca 31/12/1969 (epoch de null)
  if (d === null || d === undefined || d === '') return '—';
  // Data pura ("YYYY-MM-DD" ou "YYYY-MM-DDT00:00:00.000Z" vinda de coluna DATE):
  // formatar pelos componentes, sem passar por Date — new Date() interpreta como
  // meia-noite UTC e desloca o dia no fuso local.
  if (typeof d === 'string') {
    const m = d.match(/^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.\d+)?Z)?$/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const dt = d instanceof Date ? d : new Date(d);
  return `${String(dt.getDate()).padStart(2, '0')}/${String(dt.getMonth() + 1).padStart(2, '0')}/${dt.getFullYear()}`;
};

export const fmtMoney = (n: number | null | undefined): string => {
  // Valor ausente (extracao nao achou): travessão em vez de "R$ 0,00" enganoso
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  return 'R$ ' + Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtMoneyShort = (n: number): string => {
  if (n >= 1000) return 'R$ ' + (n / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + 'k';
  return 'R$ ' + Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
};

export const addDays = (d: Date, n: number): Date => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const isoDate = (d: Date): string => d.toISOString().slice(0, 10);

export const MESES_PT = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

export const MESES_PT_SHORT = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
